const baseURL = 'https://ceayacuiba.bitxar.com/';

export default baseURL;
